import { Injectable } from '@angular/core';

import { BrowserStorageService } from './storage.service';

@Injectable()
export class LeagueService {

	private defaultgroup:number;
	private groups:{};
	private leagues:{};

    constructor(private storage:BrowserStorageService) {
        this.initGroupinfo();
    }

	initGroupinfo() {
        this.defaultgroup = 0;
        this.groups = {};
        this.leagues = {};
	}
    
    setGroupinfo(data) {

        this.initGroupinfo();

        data.forEach(value => {
            this.groups["group" + value.groupid] = {id:value.groupid, name:value.groupname, startdate:value.startdate, enddate:value.enddate, leagueid:value.leagueid, ingroup:(value.userid != null)};
            if (value.userid != null && value.enddate > (new Date()).getTime()) this.defaultgroup = value.groupid;
            if (!this.leagues["league" + value.leagueid]) this.leagues["league" + value.leagueid] = [];
            this.leagues["league" + value.leagueid].push(value.groupid);
	    })
	    this.storage.set('groups', JSON.stringify(this.groups));
	    this.storage.set('leagues', JSON.stringify(this.leagues));
	    this.storage.set('defaultgroup', this.defaultgroup + "");
    }
    
	loadGroupinfo() {
	    this.groups = JSON.parse(this.storage.get('groups'));
	    this.leagues = JSON.parse(this.storage.get('leagues'));
	    this.defaultgroup = this.storage.get('defaultgroup');
	    if (!this.groups) this.initGroupinfo();
	}

    getDefaultGroup(): number {
    	    if (this.groups["group" + this.defaultgroup] && this.groups["group" + this.defaultgroup].ingroup) return this.defaultgroup;
    	    return 0;
    }
        
    setDefaultGroup(id) {
    	    this.defaultgroup = id;
	}
    
    getGroups(id) {
    	    if (id && this.groups["group" + id] && this.leagues["league" + this.groups["group" + id].leagueid] ) return this.leagues["league" + this.groups["group" + id].leagueid];
    	    else return [];
	}
    
    getMyGroups(id) {
        let mygroups = [];
    	if (id && this.groups["group" + id] && this.leagues["league" + this.groups["group" + id].leagueid]) {
    		this.leagues["league" + this.groups["group" + id].leagueid].forEach(i => {
      		  if (this.groups["group" + i] && this.groups["group" + i].ingroup) {
    		      mygroups.push({id:i, name:this.groups["group" + i].name});
    		  }
    		});    		
    	}
    	return mygroups;
	}
    
	getGroupname(id): string {
    	    if (id && this.groups["group" + id]) return this.groups["group" + id].name;
    	    else if (this.defaultgroup && this.groups["group" + this.defaultgroup]) return this.groups["group" + this.defaultgroup].name;
    	    else return "Unknown";
    }
        
    isGroupArchived(id): boolean {
    	    if (id && this.groups["group" + id]) return (this.groups["group" + id].enddate <= (new Date()).getTime());
    	    else if (this.defaultgroup && this.groups["group" + this.defaultgroup]) return (this.groups["group" + this.defaultgroup].enddate <= (new Date()).getTime());
    	    else return true;
	}
    
    isGroupStarted(id):boolean {
    	    if (id && this.groups["group" + id]) return (this.groups["group" + id].startdate <= (new Date()).getTime());
    	    else if (this.defaultgroup && this.groups["group" + this.defaultgroup]) return (this.groups["group" + this.defaultgroup].startdate <= (new Date()).getTime());
    	    else return true;
	}
    
    inGroup(id):boolean {
    	    if (id && this.groups["group" + id]) return this.groups["group" + id].ingroup;
    	    else if (this.defaultgroup && this.groups["group" + this.defaultgroup]) return this.groups["group" + this.defaultgroup].ingroup;
    	    else return true;
	}
}






// WEBPACK FOOTER //
// ./src/app/shared/league.service.ts